/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'ai-mate.all-chat-view.chat-item.chat-options-button-label': 'Opciones de chat para {conversationName}',
  'ai-mate.all-chat-view.chat-item.delete-label': 'Eliminar',
  'ai-mate.all-chat-view.chat-item.rename-label': 'Renombrar',
  'ai-mate.all-chat-view.new-chat-button-label': 'Nuevo chat',
  'ai-mate.chat-error-banner.description': 'Tu historial de chat se guarda durante un máximo de 30 días.',
  'ai-mate.chat-error-banner.title': 'Iniciar nuevo chat',
  'ai-mate.chat-error.description': 'Prueba a <btn>volver a cargar el chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Has alcanzado el número máximo de solicitudes. Inténtalo de nuevo más tarde.',
  'ai-mate.chat-error.rate-limited-title': 'Demasiadas solicitudes',
  'ai-mate.chat-error.rovo-inactive-description':
    'Parece que Rovo no está activado en tu sitio. <link>Configurar Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo está inactivo',
  'ai-mate.chat-error.title': 'No tenemos claro qué ha salido mal',
  'ai-mate.chat-history.loading-state.collapse-icon': 'Contraer',
  'ai-mate.chat-history.loading-state.expand-icon': 'Ampliar',
  'ai-mate.chat-history.loading-state.rovo-is-thinking': 'Rovo está pensando',
  'ai-mate.chat-input.file-close-icon-label': 'Eliminar archivo',
  'ai-mate.chat-input.file-error-icon-label': 'Error al cargar el archivo',
  'ai-mate.chat-input.store-user-messages.label':
    'Registrar este mensaje para ayudarnos a mejorar la calidad de las respuestas',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Eliminar',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Opciones de chat para {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Renombrar',
  'ai-mate.common.ui.expandable-section.collapse': 'Contraer',
  'ai-mate.common.ui.expandable-section.expand': 'Ampliar',
  'ai-mate.conversation-assistant-page-selector.page-selector-label': 'Seleccionar página',
  'ai-mate.conversation-assistant-space-selector.space-selector-label': 'Seleccionar espacio',
  'ai-mate.conversation-assistant-space-selector.suggested-spaces-heading': 'Espacios sugeridos',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Cancelar',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'La conversación que estás intentando borrar no existe.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Eliminar',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    '¿Quieres borrar la conversación "{name}"?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Se ha producido un error al borrar la conversación. Vuelve a intentarlo.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    '¿Seguro que quieres eliminar esta conversación? Esta acción no se puede deshacer.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Cancelar',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'El canal que intentas editar no existe.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Nombre',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Se ha producido un error al editar la conversación. Vuelve a intentarlo.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Editar conversación',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'El nombre es el mismo que el actual.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Guardar',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {{results,number} resultado encontrado} other {{results,number} resultados encontrados}}',
  'ai-mate.conversation-list-view.back-button.label': 'Atrás',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Cerrar chat',
  'ai-mate.conversation-list-view.header-title': 'Historial de chats',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Nuevo chat',
  'ai-mate.conversation-list-view.no-chat': 'Sin resultados',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Buscar chats',
  'ai-mate.date-time-utils.time.now': 'Justo ahora',
  'ai-mate.date-time-utils.time.yesterday': 'Ayer',
  'ai-mate.expander.hide-details': 'Ocultar detalles',
  'ai-mate.expander.show-details': 'Mostrar más detalles',
  'ai-mate.loading-status-indicator.discovery': 'En investigación',
  'ai-mate.loading-status-indicator.error': 'Error',
  'ai-mate.loading-status-indicator.info': 'Información',
  'ai-mate.loading-status-indicator.loading': 'Cargando',
  'ai-mate.loading-status-indicator.success': 'Correcto',
  'ai-mate.loading-status-indicator.todo': 'Por hacer',
  'ai-mate.loading-status-indicator.warning': 'Advertencia',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Cerrar chat',
  'ai-mate.main-chat.hamburger-menu-label': 'Menú',
  'ai-mate.main-chat.maximize-chat-button-label': 'Pantalla completa',
  'ai-mate.main-chat.minimize-chat-button-label': 'Restablecer vista',
  'ai-mate.main-chat.new-chat-button-label': 'Nuevo',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nuevo chat',
  'ai-mate.rovo-chat-header.back-home-button-label': 'Volver al inicio',
  'ai-mate.rovo-chat-header.chrome-extension-button-text': 'Extensión de Chrome',
  'ai-mate.rovo-chat-header.chrome-extension-icon-label': 'Extensión de Chrome',
  'ai-mate.rovo-chat-header.close-chat-header-button-label': 'Cerrar',
  'ai-mate.rovo-chat-header.debug-button-label': 'Depurar',
  'ai-mate.rovo-chat-header.debug-icon-label': 'Depurar',
  'ai-mate.rovo-chat-header.delete-button-text': 'Eliminar',
  'ai-mate.rovo-chat-header.delete-icon-label': 'Eliminar',
  'ai-mate.rovo-chat-header.feedback-button-text': 'Comentarios<em></em>',
  'ai-mate.rovo-chat-header.feedback-icon-label': 'Comentarios',
  'ai-mate.rovo-chat-header.floating-button-text': 'Flotante',
  'ai-mate.rovo-chat-header.floating-icon-label': 'Flotante',
  'ai-mate.rovo-chat-header.fullscreen-button-text': 'Pantalla completa',
  'ai-mate.rovo-chat-header.fullscreen-icon-label': 'Pantalla completa',
  'ai-mate.rovo-chat-header.get-help-button-text': 'Obtener ayuda',
  'ai-mate.rovo-chat-header.get-help-icon-label': 'Obtener ayuda',
  'ai-mate.rovo-chat-header.menu-button-label': 'Menú',
  'ai-mate.rovo-chat-header.more-menu-button-label': 'Más',
  'ai-mate.rovo-chat-header.new-agent-chat-button-label': 'Nuevo chat con {agentName}',
  'ai-mate.rovo-chat-header.new-chat-button-label': 'Nuevo chat',
  'ai-mate.rovo-chat-header.rename-button-text': 'Renombrar',
  'ai-mate.rovo-chat-header.rename-icon-label': 'Renombrar',
  'ai-mate.rovo-chat-header.sidebar-button-text': 'Barra lateral',
  'ai-mate.rovo-chat-header.sidebar-icon-label': 'Barra lateral',
  'ai-mate.rovo-chat-header.switch-mode-button-label': 'Cambiar a',
  'ai-mate.rovo-chat-header.switch-mode-section-text': 'Cambiar a',
  'conversation-assistant-button.ask-rovo-label': 'Preguntar a Rovo',
  'conversation-assistant-message-actions.require-information-tool.project-selector.header': 'Seleccionar un proyecto',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Enviar',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Pregúntale a la IA sobre esto',
  'highlight-actions.rovo-chat-explain-option.text': 'Explicar',
  'highlight-actions.rovo-chat-explain-prompt':
    'Explica esto reformulándolo y añadiendo más detalles, pero utiliza un lenguaje muy sencillo y frases cortas, y pon ejemplos o incluye definiciones para todos los términos técnicos empleados en el texto original.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Encontrar recursos',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Encuentra recursos únicamente de la base de conocimiento de la organización que corroboren las afirmaciones realizadas.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Proporciona ejemplos',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Pon ejemplos de esto extraídos de los recursos de la organización o del conocimiento público. Si no hay ningún recurso que se pueda proporcionar, intenta poner un ejemplo metafórico que pueda ayudar a alguien a entenderlo mejor.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Enviar comentarios',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Revisa la redacción de este texto y dame tu opinión. Haz comentarios sobre la elección de palabras, la gramática y la puntuación. Hazlo de forma positiva y entusiasta, pero aporta siempre al menos una cosa que mejorar o cambiar.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recomendaciones de chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Abrir chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Resumir',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Resalta los puntos clave de esto. Céntrate en la información esencial y excluye los detalles innecesarios. Ofrece una descripción concisa en un solo párrafo.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Preguntar en Chat',
  'highlight-actions.rovo-chat.ask-rovo-button-text': 'Preguntar a Rovo',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Plantear una pregunta al respecto.',
  'horizontal-scroll-container.scroll-left': 'Desplazarse a la izquierda',
  'horizontal-scroll-container.scroll-right': 'Desplazarse a la derecha',
  'rovo-chat.deep-research-spotlight.description':
    'Activa Investigación en detalle e introduce una indicación. Rovo creará un plan, realizará la investigación y generará un informe completo.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Descartar',
  'rovo-chat.deep-research-spotlight.heading': 'Presentamos Investigación en detalle de Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Arrastra y suelta para añadir contexto',
  'rovo-chat.message-file.icon-label': 'Archivo',
  'rovo-chat.rovo-greeting.deep-research-greeting-text': 'Manos a la obra',
  'rovo-chat.rovo-greeting.default-greeting-text': '¿En qué puedo ayudarte, {name}?',
  'rovo-chat.search-input.screen-reader-prompt':
    'Al escribir cualquier carácter en este campo, se actualizarán los resultados de la búsqueda que aparecen a continuación',
};
